import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonDatetime, IonDatetimeButton, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonModal, IonNote, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonText, IonTextarea, IonTitle, IonToggle, IonToolbar, useIonRouter, useIonViewDidEnter, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import { add, addCircleOutline, alarmOutline, arrowUpCircleOutline, checkbox, checkmarkCircleOutline, ellipseOutline, globeOutline, removeCircleOutline, warningOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import { Link } from 'react-router-dom';
import PlaceCreateEmbed from './PlaceCreateEmbed';
import RouteCreateEmbed from './RouteCreateEmbed';
import TrailCreateEmbed from './TrailCreateEmbed';
import DayOfWeekSelector, { DayKey, DAYS } from '../components/WeekdaySelector';
//import TimerProgressBar from '../components/TimerProgressBar';
import { subMinutes, addDays, addMinutes, addHours, addWeeks, addSeconds } from 'date-fns';
import { useCountdownTimer } from '../components/CountdownTimer';

const TimerCreate: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    
    const [newPlaceTokenVal, setNewPlaceTokenVal] = useState<string>('');
    const [routeTokenVal, setNewRouteTokenVal] = useState<string>('');

    const [timerFreq, setTimerFreq] = useState<string>('');
    const [typeSetting, setTypeSetting] = useState<string>('');
    const [placeSrc, setPlaceSrc] = useState<string>('');
    const [routeSrc, setRouteSrc] = useState<string>('');
    const [trailSrc, setTrailSrc] = useState<string>('');
    const [routeType, setRouteType] = useState<string>('');
    const [timerName, setTimerName] = useState<string>('');
    const [timerTimezone, setTimerTimezone] = useState<string>('');
    const [placeTimezone, setPlaceTimezone] = useState<string>('');
    const [placeDST, setPlaceDST] = useState<string>('');
    const [todayIsDST, setTodayIsDST] = useState<boolean>(false); 
    const [timerDST, setTimerDST] = useState<boolean>(false);  
    const [timerStartTimeISO, setTimerStartTimeISO] = useState<string>('');
    const [startTime, setStartTime] = useState<number>(0);
    const [timerEndTimeISO, setTimerEndTimeISO] = useState<string>('');
    const [endTime, setEndTime] = useState<number>(0);
    const [selectedDays, setSelectedDays] = useState<DayKey[]>(
        DAYS.map((day) => day.key)
    );
    const [timerDuration, setTimerDuration] = useState<string>('');
    const [alarmDelay, setAlarmDelay] = useState<any>();  
    const [timesValid, setTimesValid] = useState<boolean>(false);

    const [madeChanges, setMadeChanges] = useState<boolean>(false);
    const [otherPeopleOpen, setOtherPeopleOpen] = useState<boolean>(false);
    const [partySize, setPartySize] = useState<string>('1');
    const [selectedPartnerTokens, setSelectedPartnerTokens] = useState<any[]>([]);
    const [selectedPartnerEmails, setSelectedPartnerEmails] = useState<any[]>([]);   
    const [timerDetailOpen, setTimerDetailOpen] = useState<boolean>(false);
    const [petsOpen, setPetsOpen] = useState<boolean>(false);
    const [vehiclesOpen, setVehiclesOpen] = useState<boolean>(false);
    const [equipmentOpen, setEquipmentOpen] = useState<boolean>(false);
    const [equipment, setEquipment] = useState<any[]>([]); 
    const [checkedEquipment, setCheckedEquipment] = useState<any[]>([]); 
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true);
    
    const nameRef = useRef<any>(null);
    const typeRef = useRef<any>();
    const placeRef = useRef<any>();
    const placeTextRef = useRef<any>();
    const routeRef = useRef<any>();
    const routeTextRef = useRef<any>();        
    const routeStartTextRef = useRef<any>();
    const routeEndTextRef = useRef<any>();
    const timerDSTOverrrideRef = useRef<any>();
    const notesRef = useRef<any>();

    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, alarms, setShowLoader, level, limits, profiles, settings, places, getPlaces, startPlaces, routes, getRoutes, activePartners, getPartnerships, availableKids, setAvailableKids, kids, getKids, availablePets, setAvailablePets, pets, getPets, vehicles, getVehicles, vehiclesAll, setVehiclesAll, vehiclesStart, setVehiclesStart, vehiclesEnroute, setVehiclesEnroute, vehiclesEnd, setVehiclesEnd, selectedVehiclesStart, setSelectedVehiclesStart, selectedVehiclesEnroute, setSelectedVehiclesEnroute, selectedVehiclesEnd, setSelectedVehiclesEnd, contacts, availableContacts, setAvailableContacts, getContacts, checkedContacts, setCheckedContacts, textLogoLoaded, fadeInTextLogo, SWFullHorizLogo, SWTextDarkLogo, now, getCurrentTimers, timezonesIANA, getTimezonesIANA, userTimezone, userIANATimezone, timezoneName, showToast, present, dismiss } = useAppContext();
        
    const router = useIonRouter();

    const { updateCountdownEnd, stopCountdown } = useCountdownTimer();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => {   
        setShowLoader(true);      
        const authenticate = async () => {
            await present('Loading...');
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                dismiss();
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if (!authenticated || authenticated.mt == '') {
                    dismiss();
                    router.push('/login', 'forward');
                }
            }
            setTodayIsDST(checkDST());                
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.places > 0 && limits.routes > 0) {
            const fetchData = async () => {
                const params = new URLSearchParams(window.location.search);
                let pt = params.get('place');
                let rt = params.get('route');
                
                if (pt !== null) {
                    if (typeRef.current) typeRef.current.value = 'STATIONARY';
                    setTypeSetting('STATIONARY');
                    setPlaceSrc('saved-place'); 
                    setPlaceDST('');
                    setRouteType('');  
                    setNewPlaceTokenVal(pt);
                }                
                else if (rt !== null) {
                    if (typeRef.current) typeRef.current.value = 'MOBILE';
                    setTypeSetting('MOBILE');
                    setRouteSrc('saved-route');
                    setPlaceDST('');
                    setRouteType('');  
                    setNewRouteTokenVal(rt);
                } 

                setTodayIsDST(checkDST());
                setTimerDST(checkDST());
                await initializeDates('', '');
                await getPlaces(authorizedMember.memberToken, limits.places);
                await getRoutes(authorizedMember.memberToken, limits.routes);
                await getTimezonesIANA(authorizedMember.memberToken);
                await getPartnerships(authorizedMember.memberToken, 'all');
                await getKids(authorizedMember.memberToken, limits.kids);
                await getPets(authorizedMember.memberToken, limits.pets);
                await getVehicles(authorizedMember.memberToken, limits.vehicles);
                await getContacts(authorizedMember.memberToken, 'active', limits.contacts);
                await getEquipment(authorizedMember.memberToken);

                setLoading(false);
                dismiss();

                setShowLoader(false);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    useEffect(() => {
         const startTimeObj = new Date(timerStartTimeISO);
        const startTimeMs = startTimeObj.getTime();
        let startTimeUNIX = Math.floor(startTimeMs / 1000);        
        
        const endTimeObj = new Date(timerEndTimeISO);
        const endTimeMs = endTimeObj.getTime();
        let endTimeUNIX = Math.floor(endTimeMs / 1000);
        
        setStartTime(startTimeUNIX);   
        setEndTime(endTimeUNIX);  

        validateForm();      
    }, [timerStartTimeISO, timerEndTimeISO]); 
    

    useEffect(() => {
        const effect = async () => {
            await getTimezone(newPlaceTokenVal);
        };
        effect();
    }, [newPlaceTokenVal]);


    useEffect(() => {
        //getTimezone(routeTokenVal);
        const effect = async () => {
            await getTimezone(routeTokenVal);
        };
        effect();
    }, [routeTokenVal, nameRef]);


    /*useEffect(() => {
        if (placeTimezone == '' && userTimezone != '') initializeDates();
        if (userTimezone == '' && placeTimezone != '') initializeDates();
    }, [placeTimezone, userTimezone]); */

    
    useEffect(() => {
        setAlarmDelay(settings.delay);
    }, [settings]);


    useEffect(() => {
        validateForm();
    }, [timerFreq, routeTextRef.current, checkedContacts]);     


    useEffect(() => {
        const effect = async () => {
            if (routeTextRef.current) {
                //console.log(routeTextRef.current.value);
                generateTimerName('routeName', routeTextRef.current.value);
            }
        };
        effect();
    }, [routeTextRef.current]);

    
    //
    // Toggle the Type
    //
    const toggleTimerFreq = (f: string) => {
        setTimerFreq(f);
    };  


    //
    // Toggle the Type
    //
    const toggleTypeSetting = (t: string) => {
        setTypeSetting(t === typeSetting ? '' : t);
        setPlaceDST('');
        //setPlaceTimezone('');
        if(placeSrc === '') setPlaceSrc('saved-place'); 
        if(routeSrc === '') setRouteSrc('saved-route');   
        if(trailSrc === '') setTrailSrc('saved-trail'); 
        //setRouteType('');    
        validateForm();  
    };  


    //
    // Reset the Type
    //
    const resetTypeSetting = () => {
        setTypeSetting('');
    };  


    //
    // Toggle the Place Source
    //
    const togglePlaceSrc = (p: string) => {
        setPlaceSrc(p === placeSrc ? '' : p);
        if (placeRef.current) placeRef.current.value = '';
        nameRef.current.value = '';
        validateForm();
    }; 
    
    
    //
    // Toggle the Route Source
    //
    const toggleRouteSrc = (s: string) => {
        const src = s === routeSrc ? '' : s;
        setRouteSrc(src);
        setNewRouteTokenVal('');
        setRouteType('');
        if (routeRef.current) routeRef.current.value = '';
        nameRef.current.value = '';
        validateForm();
    }; 
    

    //
    // Toggle the Trail Source
    //
    const toggleTrailSrc = (t: string) => {
        setTrailSrc(t === trailSrc ? '' : t);
        nameRef.current.value = '';
        validateForm();
    };  


    //
    // Toggle Other People
    //
    const toggleOtherPeople = () => {
        setOtherPeopleOpen(!otherPeopleOpen);
    };  


    //
    // Toggle Pets
    //
    const togglePets = () => {
        setPetsOpen(!petsOpen);
    };  
    

    //
    // Toggle Vehicles
    //
    const toggleVehicles = () => {
        setVehiclesOpen(!vehiclesOpen);
    }; 
    
    
    //
    // Toggle Equipment
    //
    const toggleEquipment = () => {
        setEquipmentOpen(!equipmentOpen);
    }; 


    //
    // Generate the Timer Name from the Place or Route
    //
    const generateTimerName = (source: string, value: string) => {
        //console.log(source);
        validateForm();
        if (source === 'placeName') nameRef.current.value = value == '' ? '' : 'At ' + value;
        if (source === 'routeStartPlaceName')  nameRef.current.value = value == '' ? '' : 'Going from ' + value;
        if (source === 'routeName') nameRef.current.value = value == '' ? '' : value;
    };
        
    
    //
    // This is only a dummy function, to satisfy the TimerProgressBar params
    //
    const getTimer = async () => {};


    //
    // Get the Timezone of the Selected Place or Route
    //
    const getTimezone = async (prt: string) => {
        if(prt) {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('tz', prt);
            try {
                const response = await fetch('https://api.besolowise.com/timers/get/', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData
                });
                
                if(response.ok) {   
                    const obj = await response.json();
                    let dst = checkDST();
                    setTodayIsDST(dst); 
                    //setPlaceTimezone(obj.placeTimezone);
                    setPlaceDST(obj.placeUsesDST);
                    setTimerDST(obj.placeUsesDST == '2' || (obj.placeUsesDST == '1' && dst));
                    setRouteType(obj.routeType);
                    //console.log(nameRef.current, obj.routeName);
                    //if(nameRef.current && nameRef.current.value == '') 
                        nameRef.current.value = obj.routeName ? obj.routeName : 'At ' + obj.placeName;

                    if(notesRef.current) 
                        notesRef.current.value = obj.placeNotes;
                    
                } else {
                    setLoading(false);
                    showToast({
                        message: 'Response Error. Refresh this page to try again.',
                        duration: 3000,
                        color: 'danger',
                        position: 'bottom'
                    });
                }
            } catch(error) {
                setLoading(false);
                console.log(error);
                showToast({
                    message: 'Connection Error 11: ' + error + '. Refresh this page to try again.',
                    duration: 3000,
                    color: 'dark',
                    position: 'bottom'
                });
            } 
        }
    };


    //
    // Check if today is locally Daylight Savings Time
    //
    const checkDST = () => {
        const now = new Date();
        const januaryOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
        return now.getTimezoneOffset() !== januaryOffset;
    };


    //
    // Handle the change of the Time Zone setting
    //
    const handleTimeZoneChange = (e: CustomEvent) => {
        setTimerTimezone(e.detail.value);
    };


     //
    // Handle the change of the DST setting
    //
    const handleTimerDSTChange = (e: CustomEvent) => {
        setTimerDST(!timerDST);
    };


    //
    // Initialize Start and End Times
    //
    const initializeDates = async (startTimeISO:string, endTimeISO:string) => { 
        
        // Begin calculating Starting Date and Time
        const NowDate = new Date();
        const localTZOffset = NowDate.getTimezoneOffset();
        const NowLocalDate = subMinutes(NowDate, localTZOffset);
       
        const startYear = NowLocalDate.getFullYear();
        const startMonth = NowLocalDate.getMonth();
        const startDay = NowLocalDate.getDate();
        const startHour = NowLocalDate.getHours();
        const startMins = NowLocalDate.getMinutes();
        let startMinsRndDown = startMins;
        let startMinsRndUp = startMins;

        if(startMins >= 1 && startMins < 15) { startMinsRndDown = 0; startMinsRndUp = 15; }
        //if(startMins >= 7 && startMins < 15) { startMinsRndDown = 15; startMinsRndUp = 30; }

        if(startMins >= 16 && startMins < 30) { startMinsRndDown = 15; startMinsRndUp = 30; }
        //if(startMins >= 22 && startMins < 30) { startMinsRndDown = 30; startMinsRndUp = 45; }

        if(startMins >= 31 && startMins < 45) { startMinsRndDown = 30; startMinsRndUp = 45; }
        //if(startMins >= 37 && startMins < 45) { startMinsRndDown = 45; startMinsRndUp = 0; }

        if(startMins >= 46 && startMins <= 59) { startMinsRndDown = 45; startMinsRndUp = 0; }
        //if(startMins >= 52 && startMins <= 59) { startMinsRndDown = 0; startMinsRndUp = 15; }
       
        const StartDate = startTimeISO === '' ? new Date(startYear, startMonth, startDay, startHour, startMinsRndDown, 0, 0) : new Date(startTimeISO);   

        let startISO;
        let startTimestamp;

        if(startTimeISO != '') {
            const StartLocalDate = subMinutes(StartDate, localTZOffset); 
            let startLocalISO = StartLocalDate.toISOString();
            startISO = startLocalISO.slice(0, -5);
            startTimestamp = StartLocalDate.getTime();
        } else {
            let startISOFull = StartDate.toISOString();
            startISO = startISOFull.slice(0, -5);
            startTimestamp = StartDate.getTime();
        }

        setStartTime(startTimestamp);
        
        const EndDate = endTimeISO === '' ? addMinutes(StartDate, 15) : new Date(endTimeISO);  

        let endISO;
        let endTimestamp;

         if(endTimeISO != '') {
            const EndLocalDate = subMinutes(EndDate, localTZOffset); 
            let endLocalISO = EndLocalDate.toISOString();
            endISO = endLocalISO.slice(0, -5);
            endTimestamp = EndLocalDate.getTime();
        } else {
            let endISOFull = EndDate.toISOString();
            endISO = endISOFull.slice(0, -5);
            endTimestamp = EndDate.getTime();
        }

        setEndTime(endTimestamp);

        if (checkTimesOrder(startTimestamp, endTimestamp) === false) {
            /*showToast({
                    message: 'Invalid times order',
                    duration: 2000,
                    color: 'danger',
                    position: 'bottom'
                });*/
            setTimesValid(false);
            setTimerDuration(' - ');
            validateForm();
            return;
        } else {
            setTimesValid(true);
            validateForm();
        }
        
        const durationSec = Math.abs(endTimestamp - startTimestamp) / 1000;
        const durationStr = await parseTimePeriod(durationSec, false, 'floor');

        setTimerStartTimeISO(startISO);
        setTimerEndTimeISO(endISO);
        setTimerDuration(durationStr);

        return;
    };


    //
    // Handle changes in the Date and Time selections
    //
    const handleStartTimeISOChange = async (e: CustomEvent) => {
        const startTimeISO = e.detail.value as string;  
        setTimerStartTimeISO(startTimeISO);
        initializeDates(startTimeISO, timerEndTimeISO);
    };

    const handleEndTimeISOChange = async (e: CustomEvent) => {
        const endTimeISO = e.detail.value as string;
        setTimerEndTimeISO(endTimeISO);
        initializeDates(timerStartTimeISO, endTimeISO);
    };


    //
    // Validate Start Time is BEFORE End time
    //
    const checkTimesOrder = (selStartTimeStamp: number, selEndTimeStamp: number) => {
        let rtn = true;        
        rtn = selStartTimeStamp <= selEndTimeStamp;
        return rtn;
    };

    
    //
    // Parse time periods
    //
    const parseTimePeriod = async (periodSecs: number, displaySecs: boolean, round: string) => {
        const oneMinute = 60; // seconds
        const oneHour   = 60 * oneMinute;
        const oneDay    = 24 * oneHour;
        const oneWeek   = 7 * oneDay;

        let periodStr = '';
        let periodWeeksRem = 0;
        let periodDaysRem = 0;
        let periodHoursRem = 0;
        let periodMinsRem = 0;

        if(periodSecs >= oneWeek) {
            let periodWeeksDec = periodSecs / oneWeek;
            let periodWeeksInt = Math.floor(periodWeeksDec);
            periodWeeksRem = (periodWeeksDec - periodWeeksInt) * oneWeek;
            periodStr = periodWeeksInt.toString() + ' wk';
            if(periodWeeksInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodWeeksRem);
        }
        
        if(periodSecs >= oneDay) {
            let periodDaysDec = periodSecs / oneDay;
            let periodDaysInt = Math.floor(periodDaysDec);
            periodDaysRem = (periodDaysDec - periodDaysInt) * oneDay;
            periodStr = periodStr + ' ' + periodDaysInt.toString() + ' day';
            if(periodDaysInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodDaysRem);
        }
        
        if(periodSecs >= oneHour) {
            let periodHoursDec = periodSecs / oneHour;
            let periodHoursInt = Math.floor(periodHoursDec);
            periodHoursRem = (periodHoursDec - periodHoursInt) * oneHour;
            periodStr = periodStr + ' ' + periodHoursInt.toString() + ' hr';
            if(periodHoursInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodHoursRem);
        }
        
        if(periodSecs >= oneMinute) {
            let periodMinutesDec = periodSecs / oneMinute;            
            let periodMinutesInt = round == 'ceil' ? Math.ceil(periodMinutesDec) : Math.floor(periodMinutesDec);
            periodMinsRem = (periodMinutesDec - periodMinutesInt) * oneMinute;
            if(periodMinutesInt == 60) periodMinutesInt = 59;
            periodStr = periodStr + ' ' + periodMinutesInt.toString() + ' min';
            if(periodMinutesInt >= 2) periodStr += 's';
            periodSecs = Math.ceil(periodMinsRem);
        } else if(periodSecs < oneMinute && periodStr == '') {
            periodStr = periodStr + ' < 1 min';
        }

        if (displaySecs) {
            if(periodSecs >= 1) {
                periodStr = periodStr + ' ' + periodSecs.toString() + ' sec';
            } else if(periodSecs == 0) {
                periodStr = periodStr + ' 00 sec'
            }
        }

        return periodStr;
    };


    const handleAlarmDelayChange = (e: CustomEvent) => {
        setAlarmDelay(e.detail.value);
    };

    const isEqual = (obj1: any, obj2: any) => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    };
    
    //
    // Handle change of Party Size
    //
    const handlePartySizeChange = (e: CustomEvent) => {
        const newPartySize = e.detail.value; 
        setPartySize(newPartySize);
        if(newPartySize == '0') removePartnerObjects();
    };
    

    //
    // Get or Remove each Partner's associated objects as the Partner is selected
    //
    const getPartnerObjects = async (e: CustomEvent) => {
        let em = '';
        const pt = e.detail.value; 
        const checked = e.detail.checked;

        // Get selected Partner Email
        activePartners.forEach((item:any, index:any, arr:any) => {
            if(item.token == pt) em = item.email;
        }); 

        // Fill array of all contactEmails        
        let contactEmails: any = [];
        availableContacts.forEach((item:any, index:any, arr:any) => {
            contactEmails.push(item.contactEmail);
        });         

        // Keep track of selected Partners, primarily for conditional Contacts
        let selPartnerTokens = selectedPartnerTokens;
        let selPartnerEmails = selectedPartnerEmails;
        if(checked) {
            selPartnerTokens.push(pt);
            selPartnerEmails.push(em);
        } else {
            const emailIndex = selPartnerEmails.indexOf(em);
            const tokenIndex = selPartnerTokens.indexOf(pt);
            const xE = selPartnerEmails.splice(emailIndex, 1);
            const xT = selPartnerTokens.splice(tokenIndex, 1);
        }
        setSelectedPartnerTokens(selPartnerTokens);
        setSelectedPartnerEmails(selPartnerEmails);

        try {
            const formData = new FormData();
            formData.append('pt', pt);
            formData.append('mt', authKey.mt);
            const response = await fetch('https://api.besolowise.com/partners/objects/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const obj = await response.json();  

                // Handle Kids array
                //
                let newKids;
                const partnerKids = Object.values(obj.kids);
                if(checked) {
                    newKids = [...availableKids];
                    partnerKids.forEach((item:any, index:any, arr:any) => {
                        newKids.push(item);
                    });
                } else {
                    newKids = availableKids.filter( function( item:any ) {
                        return !partnerKids.some(obj => isEqual(obj, item));
                    } );
                } 
                setAvailableKids(newKids);
                

                // Handle Pets array
                //
                let newPets;
                const partnerPets = Object.values(obj.pets);
                if(checked) {
                    newPets = [...availablePets];
                    partnerPets.forEach((item:any, index:any, arr:any) => {
                        newPets.push(item);
                    });
                } else {
                    newPets = availablePets.filter( function( item:any ) {
                        return !partnerPets.some(obj => isEqual(obj, item));
                    } );
                }                    
                setAvailablePets(newPets);


                // Handle Vehicles array
                //
                let newVehicles;
                let selVehiclesStart = selectedVehiclesStart;
                let selVehiclesEnroute = selectedVehiclesEnroute;
                let selVehiclesEnd = selectedVehiclesEnd;

                let newVehiclesStart: any = [];
                let newVehiclesEnroute: any = [];
                let newVehiclesEnd: any = [];
                const partnerVehicles = Object.values(obj.vehicles);

                if(checked) {
                    newVehicles = [...vehiclesAll];
                    partnerVehicles.forEach((item:any, index:any, arr:any) => {
                        newVehicles.push(item);
                    });
                } else {
                    newVehicles = vehiclesAll.filter( function( item: any ) {
                        return !partnerVehicles.some(obj => isEqual(obj, item));
                    } );
                }
                // Re-sort and set
                newVehicles.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
                setVehiclesAll(newVehicles);

                newVehicles.forEach((item:any, index:any, arr:any) => {
                    if(selVehiclesStart.indexOf(item.vehicleToken) >= 0 || (selVehiclesEnroute.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesStart.push(item);
                });
                setVehiclesStart(newVehiclesStart);
        
                newVehicles.forEach((item:any, index:any, arr:any) => {
                    if(selVehiclesEnroute.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesEnroute.push(item);
                });
                setVehiclesEnroute(newVehiclesEnroute);
        
                newVehicles.forEach((item:any, index:any, arr:any) => {
                    if(selVehiclesEnd.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0 && selVehiclesEnroute.indexOf(item.vehicleToken) < 0)) newVehiclesEnd.push(item);
                });
                setVehiclesEnd(newVehiclesEnd); 

                // Handle Contacts array
                //
    
                let newContacts: any = [];
                const partnerContacts = Object.values(obj.contacts);
                
                if(checked) {
                    // Contacts list cannot contain Self or a Selected Partner
                    availableContacts.forEach((item:any, index:any, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && item.contactEmail != authorizedMember.memberEmail) newContacts.push(item);
                    });
                    
                    // Partner's Contacts cannot contain Self (primary user) or duplicates of Contacts
                    partnerContacts.forEach((item:any, index:any, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && 
                            contactEmails.indexOf(item.contactEmail) < 0 && 
                            item.contactEmail != authorizedMember.memberEmail 
                            ) newContacts.push(item);
                    });
                } else {
                    // Remove Partner's Contacts
                    newContacts = availableContacts.filter( function( item: any ) {
                        return !partnerContacts.some(obj => isEqual(obj, item));
                    } );

                    // Re-add Partner as Contact if not selected
                    let reAddContacts = contacts.filter( function( item: any ) {
                        return !availableContacts.some((obj: any) => isEqual(obj, item));
                    } );

                    reAddContacts.forEach((item:any, index:any, arr:any) => {
                        newContacts.push(item);
                    });

                    // Contacts list cannot contain Self or a Selected Partner
                    const newContactsTemp = [...newContacts];
                    newContacts = [];
                    newContactsTemp.forEach((item:any, index:any, arr:any) => {
                        if(selPartnerEmails.indexOf(item.contactEmail) < 0 && item.contactEmail != authorizedMember.memberEmail) newContacts.push(item);
                    });                
                }

                let newChecked = [...checkedContacts];
                partnerContacts.forEach((item:any, index:any, arr:any) => {
                    if(item.contactAlwaysUse == '1') newChecked.push(item.contactToken);                    
                }); 
                setCheckedContacts(newChecked);

                // Re-sort and set availableContacts
                newContacts.sort((a: any, b: any) => (a.contactLastName > b.contactLastName) ? 1 : ((b.contactLastName > a.contactLastName) ? -1 : 0))
                setAvailableContacts(newContacts);

            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error.',
                    duration: 1000,
                    color: 'danger',
                    position: 'bottom'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }
        
    };


    //
    // Remove all Partners and associated objects
    //
    const removePartnerObjects = async () => {                
        setSelectedPartnerTokens([]);
        setSelectedPartnerEmails([]);
        setAvailableKids(kids);
        setAvailablePets(pets);
        setVehiclesAll(vehicles);
        setVehiclesStart(vehicles);
        setVehiclesEnroute(vehicles);
        setVehiclesEnd(vehicles);
        setSelectedVehiclesStart([]);
        setSelectedVehiclesEnroute([]);
        setSelectedVehiclesEnd([]);
        setAvailableContacts(contacts);
    };


    const handleContactSelection = (e: CustomEvent, contactToken: string) => {
        const isChecked = e.detail.checked;
      
        setCheckedContacts((prevCheckedContacts: any) => {
          // Add or remove the contact token based on the checkbox status
          return isChecked
            ? [...prevCheckedContacts, contactToken]
            : prevCheckedContacts.filter((token: any) => token !== contactToken);
        });

        validateForm();
    };     
    
    
    const toggleTimerDetailOpen = () => {
        setTimerDetailOpen(!timerDetailOpen);
    };


    // Handle Vehicle selection
    const handleVehicleSelect = async (e: any) => {

        const vt = e.detail.value; 
        const checked = e.detail.checked;
        const id = e.target.id;
        
        let selVehiclesStart = selectedVehiclesStart;
        let selVehiclesEnroute = selectedVehiclesEnroute;
        let selVehiclesEnd = selectedVehiclesEnd;

        let newVehiclesStart: any = [];
        let newVehiclesEnroute: any = [];
        let newVehiclesEnd: any = [];
        
        switch(id) {
            case 'vehicleTokensStart':
                
                // Keep track of selected vehiclesStart
                if(checked) {
                    selVehiclesStart.push(vt);
                } else {
                    const tokenIndex = selVehiclesStart.indexOf(vt);
                    const xT = selVehiclesStart.splice(tokenIndex, 1);
                }
                setSelectedVehiclesStart(selVehiclesStart);    

                break;

            case 'vehicleTokensEnroute':
                
                // Keep track of selected vehiclesEnroute
                if(checked) {
                    selVehiclesEnroute.push(vt);
                } else {
                    const tokenIndex = selVehiclesEnroute.indexOf(vt);
                    const xT = selVehiclesEnroute.splice(tokenIndex, 1);
                }
                setSelectedVehiclesEnroute(selVehiclesEnroute);    

                break;

            case 'vehicleTokensEnd':
                
                // Keep track of selected vehiclesEnd
                if(checked) {
                    selVehiclesEnd.push(vt);
                } else {
                    const tokenIndex = selVehiclesEnd.indexOf(vt);
                    const xT = selVehiclesEnd.splice(tokenIndex, 1);
                }
                setSelectedVehiclesEnd(selVehiclesEnd);    

                break;
        }

        vehiclesAll.forEach((item:any, index:any, arr:any) => {
            if(selVehiclesStart.indexOf(item.vehicleToken) >= 0 || (selVehiclesEnroute.indexOf(item.vehicleToken) < 0 && selVehiclesEnd.indexOf(item.vehicleToken) < 0)) newVehiclesStart.push(item);
        });
        // Re-sort and set
        newVehiclesStart.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesStart(newVehiclesStart);

        vehiclesAll.forEach((item:any, index:any, arr:any) => {
            if(selVehiclesEnroute.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnroute.push(item);
        });
        newVehiclesEnroute.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesEnroute(newVehiclesEnroute);

        vehiclesAll.forEach((item:any, index:any, arr:any) => {
            if(selVehiclesEnd.indexOf(item.vehicleToken) >= 0 || (selVehiclesStart.indexOf(item.vehicleToken) < 0)) newVehiclesEnd.push(item);
        });
        newVehiclesEnd.sort((a: any, b: any) => (a.vehicleYear > b.vehicleYear) ? 1 : ((b.vehicleYear > a.vehicleYear) ? -1 : 0))
        setVehiclesEnd(newVehiclesEnd);                
         
    };


    const handleEquipmentSelect = (e: CustomEvent, equipmentID: string) => {
        const isChecked = e.detail.checked;
      
        setCheckedEquipment((prevCheckedEquipment: any) => {
          // Add or remove the equipmentID based on the checkbox status
          return isChecked
            ? [...prevCheckedEquipment, equipmentID]
            : prevCheckedEquipment.filter((id: any) => id !== equipmentID);
        });
    };   


    //
    // Validate the form
    //
    const validateForm = () => {
        const place = placeRef.current !== undefined && placeRef.current !== null ? placeRef.current.value : '';
        const placeText = placeTextRef.current !== undefined && placeTextRef.current !== null ? placeTextRef.current.value : '';
        const route = routeRef.current !== undefined && routeRef.current !== null ? routeRef.current.value : '';
        const routeText = routeTextRef.current !== undefined && routeTextRef.current !== null ? routeTextRef.current.value : '';
        const routeStartText = routeStartTextRef.current !== undefined && routeStartTextRef.current !== null ? routeStartTextRef.current.value : '';
        const routeEndText = routeEndTextRef.current !== undefined && routeEndTextRef.current !== null ? routeEndTextRef.current.value : '';
        //const timesValid = checkTimesOrder(startTime, endTime);

        const freqValid  = timerFreq != '';

        const placeValid = (place !== undefined && place.length > 2) || (placeText !== undefined && placeText.length > 2);

        const routeValid = (route !== undefined && route.length > 2) || (routeText !== undefined && routeText.length > 2);
                            // ((routeStartText === undefined || routeStartText.length < 2) || 
                            // (routeEndText === undefined || routeEndText.length < 2));

        console.log(freqValid, placeValid, routeValid, checkedContacts.length);
       
        const disable = ( !freqValid ||
                          (!placeValid && !routeValid) ||
                          checkedContacts.length < 1);

        setDisableSubmit(disable);
    };
    
    const insertTimer = async (e: any) => {        
        e.preventDefault();
        await present('Saving Timer...');
        stopCountdown();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/timers/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 

                //console.log(obj);
                //return;
                
                //if(obj.success) router.push('/account/timers', 'back');
                if(obj.success) {
                    await getCurrentTimers(authKey.token);    
                    profiles.timers = profiles.timers + 1;              
                    setTimeout(() => {
                        dismiss();
                        if (timerFreq === 'onetime')
                            router.push('/account/timer/view/' + obj.tt, 'back')
                        if (timerFreq === 'daily')
                            router.push('/account/timer/view-daily/' + obj.tt, 'back')
                    }, 2000);
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    dismiss();
                    showToast({
                        message: obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                dismiss();
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            dismiss();
            showToast({
                message: 'Connection Error: Couldn\'t create this Timer. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'bottom'
            });
        }       
    };

    
    //
    // Get Equipment
    //

    const getEquipment = async (mt:string) => {
        try {
          const formData = new FormData();
          formData.append('mt', mt);
          const response = await fetch('https://api.besolowise.com/equipment/get/', {
              method: 'POST',
              credentials: 'include',
              body: formData
          });

          if(response.ok) {   
              const obj = await response.json();
              
              if(obj) {
                  setEquipment(() => obj);
                  return true;
              } else {
                  showToast({
                      message: 'Data Error',
                      duration: 1000,
                      color: 'danger',
                      position: 'bottom'
                  });
              }
          } else {
              showToast({
                  message: 'Response Error',
                  duration: 1000,
                  color: 'danger',
                  position: 'bottom'
              });
          }
      } catch(error) {
          showToast({
              message: 'No Connection',
              duration: 2000,
              color: 'danger',
              position: 'bottom'
          });
      } 
    };

    
    useIonViewWillLeave(() => { 
        setTimerFreq('');
        let tr = typeRef.current?.value;
        if (tr == 'STATIONARY') {
            setNewPlaceTokenVal('');
            placeRef.current.value = '';
        } else if (tr == 'MOBILE') {
            setNewRouteTokenVal('');
            routeRef.current.value = '';
        }
        setTypeSetting('');
        if (nameRef.current) nameRef.current.value = '';        
        if (typeRef.current) typeRef.current.value = ''; 
        if (notesRef.current) notesRef.current.value = '';        
    }); 


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/account/timers'>Timers</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={alarmOutline}></IonIcon> Set a New Timer<br /><span>Schedule a check-in for a one-time event or to automatically recur</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                {!loading && alarms >= limits?.timers &&
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                You've reached the monthly limit of Alarms for your current plan.
                            </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can not create a new Timer until one of your Alarms expires after one month. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can add more Alarms by upgrading to a SoloWise Premium plan. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>                            
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                            </p>
                        </IonCardContent>
                    </IonCard>
                } 

                {alarms < limits?.timers &&
                <form name='timerForm' onSubmit={insertTimer}>
                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid>
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2><IonText color={'tertiary'}>When?</IonText></h2>                                         
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Select a Frequency for this Timer</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonButton 
                                            className='ion-text-start'
                                            color={timerFreq == 'onetime' ? 'secondary' : 'tertiary'} 
                                            fill={timerFreq == 'onetime' ? 'solid' : 'outline'} 
                                            onClick={() => toggleTimerFreq('onetime')} 
                                            style={{'width': '135px'}}>
                                                <IonIcon slot="start" className='ion-float-left' icon={timerFreq == 'onetime' ? checkmarkCircleOutline : ellipseOutline}></IonIcon>
                                                One-time
                                        </IonButton>
                                        <IonButton 
                                            className='ion-text-start'
                                            color={timerFreq == 'daily' ? 'secondary' : 'tertiary'} 
                                            fill={timerFreq == 'daily' ? 'solid' : 'outline'} 
                                            onClick={() => toggleTimerFreq('daily')} 
                                            style={{'width': '135px'}}>
                                                <IonIcon slot="start" icon={timerFreq == 'daily' ? checkmarkCircleOutline : ellipseOutline}></IonIcon>
                                                Daily
                                        </IonButton>

                                        <input type='hidden' name='timerFrequency' value={timerFreq} />
                                    </IonCol>   
                                </IonRow>

                                <div className={timerFreq === '' ? 'form-section closed' : 'form-section opened'}>
                                    
                                    <IonRow>
                                        <IonCol>
                                            <IonCard className='ion-no-margin'>
                                                <IonCardContent>

                                                    <IonRow>
                                                        <IonCol size='12'>
                                                            <h2><b><IonText color={'tertiary'}>Set the {timerFreq === 'daily' ? 'Daily' : 'One-Time'} Schedule</IonText></b></h2>
                                                        </IonCol>
                                                    </IonRow>

                                                    {timerEndTimeISO != '' &&
                                                    (<>
                                                        {timerFreq === 'onetime' &&
                                                          <>
                                                            <IonRow>                                                               
                                                                <IonCol size='12' sizeSm='6'>
                                                                    <IonLabel color={'dark'}><b>Starting Date & Time</b></IonLabel>
                                                                    <IonRow className='ion-margin-bottom ion-margin-top'>
                                                                        <IonCol sizeXs='12'>
                                                                            <IonDatetimeButton datetime="start-datetime" className='ion-float-start'></IonDatetimeButton>
                                                                            <IonModal keepContentsMounted={true}>
                                                                                <IonDatetime 
                                                                                    id="start-datetime"
                                                                                    color={'tertiary'}
                                                                                    locale="en-US"
                                                                                    minuteValues='0,15,30,45'
                                                                                    name='timerStartTime'
                                                                                    preferWheel={false}
                                                                                    showDefaultButtons={true}
                                                                                    value={timerStartTimeISO}
                                                                                    onIonChange={handleStartTimeISOChange}
                                                                                ></IonDatetime>
                                                                            </IonModal>
                                                                        </IonCol>
                                                                    </IonRow>
                                                                </IonCol>                              
                                                                
                                                                <IonCol size='12' sizeSm='6'>
                                                                    <IonLabel color={'dark'}><b>Check-in Date & Time</b></IonLabel>
                                                                    <IonRow className='ion-margin-bottom ion-margin-top'>
                                                                        <IonCol sizeXs='12'>
                                                                            <IonDatetimeButton datetime="end-datetime" className='ion-float-start'></IonDatetimeButton>
                                                                            <IonModal keepContentsMounted={true}>
                                                                                <IonDatetime 
                                                                                    id="end-datetime"
                                                                                    color={'tertiary'}
                                                                                    minuteValues='0,15,30,45'
                                                                                    name='timerEndTime'
                                                                                    preferWheel={false}
                                                                                    showDefaultButtons={true}
                                                                                    value={timerEndTimeISO}
                                                                                    onIonChange={handleEndTimeISOChange}
                                                                                ></IonDatetime>
                                                                            </IonModal>
                                                                        </IonCol>                                            
                                                                    </IonRow>
                                                                </IonCol>                      
                                                            </IonRow>
                                                            
                                                            {!timesValid &&
                                                            <IonRow className='ion-margin-bottom'>
                                                                <IonCol className='ion-padding ion-text-center' size='12'>                                            
                                                                    <IonText color={'danger'}><strong><IonIcon icon={arrowUpCircleOutline}></IonIcon> Invalid Time Selection: The Check-in Time must be later than the Starting Time</strong></IonText>                                            
                                                                </IonCol>
                                                            </IonRow>
                                                            }                                                        
                                                                    
                                                            <IonRow className='ion-margin-bottom'>
                                                                <IonCol size='12' sizeSm='6'>
                                                                    <IonLabel color={'dark'}><b>Duration:</b></IonLabel> <IonChip outline={true}><b>{timerDuration}</b></IonChip>
                                                                </IonCol>
                                                            </IonRow>

                                                            <IonRow className='ion-margin-bottom'>
                                                                <IonCol size='12'>
                                                                    <IonLabel color={'dark'}><b>Time Zone of the check-in location</b></IonLabel>
                                                                </IonCol>
                                                                <IonCol size='12' sizeSm='6' sizeMd='4'>  
                                                                    <IonSelect 
                                                                        fill='outline' 
                                                                        labelPlacement='stacked' 
                                                                        name='timerTimezone' 
                                                                        onIonChange={handleTimeZoneChange} 
                                                                        placeholder='Select a Timezone' 
                                                                        value={timerTimezone === '' ? userIANATimezone : timerTimezone}>
                                                                            {timezonesIANA.map((zone: any, index: number) => (
                                                                                <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                                            ))}                                            
                                                                    </IonSelect>
                                                                </IonCol>   
                                                            </IonRow>
                                                          </>
                                                        }

                                                        {timerFreq === 'daily' &&
                                                          <>
                                                            <IonRow className='ion-margin-bottom'>
                                                                <IonCol size='12' sizeSm='4'>
                                                                    <IonLabel color={'dark'}><b>Check-in Time Each Day</b></IonLabel>                       
                                                                    <IonRow className='ion-margin-top ion-margin-bottom'>
                                                                        <IonCol sizeXs='12'>
                                                                            <IonDatetimeButton 
                                                                                datetime="end-datetime" 
                                                                                className='ion-float-start ion-margin-bottom'
                                                                                style={{'scale': '1.4', 'marginLeft': '20px'}}>
                                                                            </IonDatetimeButton>
                                                                            <IonModal keepContentsMounted={true}>
                                                                                <IonDatetime 
                                                                                    id="end-datetime"
                                                                                    color={'tertiary'}
                                                                                    presentation="time"
                                                                                    minuteValues='0,15,30,45'
                                                                                    name='timerEndTime'
                                                                                    preferWheel={false}
                                                                                    showDefaultButtons={true}
                                                                                    value={timerEndTimeISO}
                                                                                    onIonChange={handleEndTimeISOChange}
                                                                                ></IonDatetime>
                                                                            </IonModal>
                                                                        </IonCol>                                            
                                                                    </IonRow>
                                                                </IonCol>    

                                                                <IonCol size='12' sizeSm='4'>
                                                                    <IonLabel color={'dark'}><b>Time Zone of the check-in location</b></IonLabel>
                                                                    <IonSelect 
                                                                        className='ion-margin-top'
                                                                        fill='outline' 
                                                                        labelPlacement='stacked' 
                                                                        name='timerTimezone' 
                                                                        onIonChange={handleTimeZoneChange} 
                                                                        placeholder='Select a Timezone' 
                                                                        value={timerTimezone === '' ? userIANATimezone : timerTimezone}>
                                                                            {timezonesIANA.map((zone: any, index: number) => (
                                                                                <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                                                            ))}                                            
                                                                    </IonSelect>
                                                                </IonCol>   
                                                            </IonRow>

                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonLabel color={'dark'}><b>Days of the Week</b></IonLabel>
                                                                </IonCol>
                                                                <IonCol size='12'>                                                
                                                                    <DayOfWeekSelector 
                                                                        selectedDays={selectedDays}
                                                                        onSelectedDaysChange={setSelectedDays}
                                                                        setMadeChanges={setMadeChanges} />
                                                                </IonCol> 
                                                            </IonRow>
                                                          </>
                                                        }

                                                    </>)
                                                    } 
                                                                                      

                                                    <IonRow className='ion-margin-bottom'>
                                                        <IonCol size='12'>
                                                            <IonText><IonIcon color={'warning'} icon={warningOutline}></IonIcon> <em>At the Check-in time, please remember that you must be in a location that has an internet or cellular connection.</em></IonText><br /><br />
                                                            <IonLabel color={'dark'}><b>Alarm Delay</b></IonLabel><br />
                                                            <IonText>This delay is a grace period, giving you some extra time to check in, in case you forget or are running later than expected.</IonText>
                                                        </IonCol>                                    
                                                        <IonCol size='12' sizeSm='6' sizeMd='4'>                                    
                                                            <IonSelect className='ion-margin-top' fill='outline' label='Alarm Delay Period' labelPlacement='stacked' name='timerAlarmDelay' onIonChange={handleAlarmDelayChange} value={alarmDelay === undefined ? '0' : alarmDelay}>
                                                                <IonSelectOption value='0'>No delay</IonSelectOption>
                                                                <IonSelectOption value='0.25'>15 minutes</IonSelectOption>
                                                                <IonSelectOption value='0.5'>30 minutes</IonSelectOption>
                                                                <IonSelectOption value='1'>1 hour</IonSelectOption>
                                                                <IonSelectOption value='2'>2 hours</IonSelectOption>
                                                                <IonSelectOption value='3'>3 hours</IonSelectOption>
                                                                <IonSelectOption value='6'>6 hours</IonSelectOption>
                                                                <IonSelectOption value='12'>12 hours</IonSelectOption>
                                                                <IonSelectOption value='24'>24 hours</IonSelectOption>
                                                            </IonSelect>             
                                                        </IonCol>
                                                    </IonRow>
                                                </IonCardContent>
                                            </IonCard>
                                        </IonCol>
                                    </IonRow>
                                </div>

                            </IonGrid>
                        </IonCardContent>
                    </IonCard>

                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid> 
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2><IonText color={'tertiary'}>Where?</IonText></h2>
                                        <IonLabel color={'dark'}><b>Are you going somewhere, or are you staying in one place during this Timer?</b></IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol className='ion-no-padding' size='12'>
                                             
                                            <IonRow>
                                                
                                                <IonCol size='12' sizeMd='4'>                                         
                                                    <IonCard className={typeSetting === 'MOBILE' ? 'timer_where_card_selected' : 'timer_where_card'} onClick={() => toggleTypeSetting('MOBILE')}>
                                                        <IonCardContent>
                                                            <IonText><strong>I'm going somewhere</strong><br />(General activities)</IonText>
                                                            <IonNote>Errands, appointments, commuting, traveling, etc.</IonNote>
                                                        </IonCardContent>
                                                    </IonCard>
                                                </IonCol>
                                               
                                                <IonCol size='12' sizeMd='4'>                                         
                                                    <IonCard className={typeSetting === 'MOBILE_TRAIL' ? 'timer_where_card_selected' : 'timer_where_card'} onClick={() => toggleTypeSetting('MOBILE_TRAIL')}>
                                                        <IonCardContent>
                                                            <IonText><strong>I'm going somewhere</strong><br />(Trail/Outdoor activities)</IonText>
                                                            <IonNote>Hiking, walking, running, biking, fishing, boating, etc.</IonNote>
                                                        </IonCardContent>
                                                    </IonCard>
                                                </IonCol>
                                               
                                                <IonCol size='12' sizeMd='4'>
                                                    <IonCard className={typeSetting === 'STATIONARY' ? 'timer_where_card_selected' : 'timer_where_card'} onClick={() => toggleTypeSetting('STATIONARY')}>
                                                        <IonCardContent>
                                                            <IonText><strong>I'm staying in one place</strong><br />(Indoor activities)</IonText>
                                                            <IonNote>Staying at home, work, a hotel, a campsite, etc.</IonNote>
                                                        </IonCardContent>                                                
                                                    </IonCard>
                                                </IonCol>

                                                <input type='hidden' name='timerType' value={typeSetting} />
                                               
                                            </IonRow>
                                            {/*typeSetting !== '' &&
                                            <IonRow>
                                                 <IonCol size='12' className='ion-text-start ion-padding-start'>
                                                    <div className='link' onClick={resetTypeSetting}>Change</div>
                                                 </IonCol>
                                            </IonRow>
                                            */}
                                    </IonCol>                                  
                                </IonRow>

                                { typeSetting != '' &&
                                <IonRow className='ion-margin-bottom'>
                                    <IonCol className='ion-no-padding'>
                                        <IonCard className='ion-no-margin' style={{'borderTop': 'none'}}>
                                            <IonCardContent>
                                                { typeSetting === 'STATIONARY' &&
                                                    (<>
                                                        <IonGrid>
                                                            <IonRow>
                                                                <IonCol className='ion-no-padding'>
                                                                    <h2><b><IonText color={'tertiary'}>Tell us where you'll be staying</IonText></b></h2>
                                                                    <IonLabel color={'dark'}>Select a saved Place or enter a new Place</IonLabel>
                                                                </IonCol>
                                                            </IonRow>
                                                            
                                                            {placeSrc === 'new-place' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => togglePlaceSrc('saved-place')} >
                                                                            Select a Saved Place
                                                                    </IonButton>
                                                                </IonCol> 
                                                            </IonRow>
                                                            }

                                                            {placeSrc === 'saved-place' &&
                                                            <IonRow className='ion-margin-bottom'>                                                 
                                                                <IonCol className='ion-no-padding'> 
                                                                    <IonSelect className='ion-margin-top' fill='outline' label='Select a Place' labelPlacement='stacked' name='placeToken' 
                                                                    onIonChange={(e) => {
                                                                        setNewPlaceTokenVal(e.detail.value);
                                                                        getTimezone(e.detail.value);
                                                                        validateForm();
                                                                    }}
                                                                    placeholder='Saved Places' 
                                                                    ref={placeRef}
                                                                    value={newPlaceTokenVal}>
                                                                        {Array.isArray(places) &&
                                                                            (places
                                                                                .filter((p: any) => p.placeSaved == '1')
                                                                                .map((place:any, index:any) => (
                                                                                <IonSelectOption key={index} value={place.placeToken}>{place.placeName}</IonSelectOption>
                                                                            )))
                                                                        }                                           
                                                                    </IonSelect>                       
                                                                </IonCol>       
                                                            </IonRow>
                                                            }

                                                            {placeSrc === 'new-place' &&                                                              
                                                            <IonRow className='ion-margin-top'>
                                                                <IonCol size='12' className='ion-no-padding'>
                                                                    <IonLabel color={'dark'}><b>Enter a New Place</b></IonLabel><br />
                                                                    <PlaceCreateEmbed onPlaceNameChange={generateTimerName} placeTextRef={placeTextRef} />
                                                                </IonCol>
                                                            </IonRow>  
                                                            }

                                                            {placeSrc === 'saved-place' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => togglePlaceSrc('new-place')}>
                                                                            Enter a New Place
                                                                    </IonButton>                                                                   
                                                                </IonCol> 
                                                            </IonRow>
                                                            }

                                                        </IonGrid>
                                                    </>
                                                    )
                                                }

                                                { typeSetting === 'MOBILE' &&
                                                    (<>
                                                        <IonGrid>
                                                            <IonRow>
                                                                <IonCol size='12' className='ion-no-padding'>
                                                                    <h2><b><IonText color={'tertiary'}>Tell us where you'll be going</IonText></b></h2>
                                                                    <IonNote color={'dark'}>Select a saved Route or enter a new Route</IonNote>
                                                                </IonCol>
                                                            </IonRow> 

                                                            {routeSrc === 'new-route' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => toggleRouteSrc('saved-route')} >
                                                                            Select a Saved Route
                                                                    </IonButton>
                                                                </IonCol> 
                                                            </IonRow>
                                                            }

                                                            {routeSrc === 'new-route' &&                                                             
                                                            <IonRow className='ion-margin-top'>
                                                                <IonCol size='12' className='ion-no-padding'>
                                                                    <IonLabel color={'dark'}><b>Enter a New Route</b></IonLabel><br />
                                                                    <RouteCreateEmbed nameRef={nameRef} routeType={routeType} setRouteType={setRouteType} routeTextRef={routeTextRef} routeStartTextRef={routeStartTextRef} routeEndTextRef={routeEndTextRef} onRouteNameChange={generateTimerName} />
                                                                </IonCol>
                                                            </IonRow>
                                                            }
 
                                                            {routeSrc === 'saved-route' &&  
                                                            <IonRow>                                                    
                                                                <IonCol size='12' className='ion-no-padding'> 
                                                                    <IonSelect className='ion-margin-bottom ion-margin-top' fill='outline' label='Select a Route' labelPlacement='stacked' name='routeToken'
                                                                    onIonChange={(e) => {
                                                                        setNewRouteTokenVal(e.detail.value);
                                                                        getTimezone(e.detail.value);
                                                                        validateForm();
                                                                    }} 
                                                                    placeholder='Saved Routes'
                                                                    ref={routeRef}
                                                                    value={routeTokenVal}>
                                                                        {Array.isArray(routes) &&
                                                                        (routes
                                                                            .filter((rte: any) => rte.isSaved == '1')
                                                                            .map((route:any, index:any) => (
                                                                            <IonSelectOption key={index} value={route.token}>{route.name}</IonSelectOption>
                                                                        )))
                                                                        }                                            
                                                                    </IonSelect>                       
                                                                </IonCol>                                                         
                                                            </IonRow>
                                                            }

                                                            {routeSrc === 'saved-route' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => toggleRouteSrc('new-route')}>
                                                                            Enter a New Route
                                                                    </IonButton>                                                                   
                                                                </IonCol> 
                                                            </IonRow>
                                                            }

                                                        </IonGrid>
                                                    </>)
                                                }

                                                { typeSetting === 'MOBILE_TRAIL' &&
                                                    (<>
                                                        <IonGrid>
                                                            <IonRow>
                                                                <IonCol size='12' className='ion-no-padding'>
                                                                    <h2><b><IonText color={'tertiary'}>Tell us about the trail you'll be taking</IonText></b></h2>
                                                                    <IonNote color={'dark'}>Select a saved Route or enter a new Trail</IonNote>
                                                                </IonCol>
                                                            </IonRow> 

                                                            {trailSrc === 'new-trail' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => toggleTrailSrc('saved-trail')} >
                                                                            Select a Saved Trail
                                                                    </IonButton>
                                                                </IonCol> 
                                                            </IonRow>
                                                            }

                                                            {trailSrc === 'saved-trail' && 
                                                            <IonRow>                                                    
                                                                <IonCol size='12' className='ion-no-padding'> 
                                                                    <IonSelect className='ion-margin-bottom ion-margin-top' fill='outline' label='Select a Trail' labelPlacement='stacked' name='routeToken'
                                                                    onIonChange={(e) => {
                                                                        setNewRouteTokenVal(e.detail.value);
                                                                        getTimezone(e.detail.value);
                                                                        validateForm();
                                                                    }} 
                                                                    placeholder='Saved Trails'
                                                                    ref={routeRef}
                                                                    value={routeTokenVal}>
                                                                        {Array.isArray(routes) &&
                                                                        (routes
                                                                            .filter((rte: any) => rte.isSaved == '1')
                                                                            .map((route:any, index:any) => (
                                                                            <IonSelectOption key={index} value={route.token}>{route.name}</IonSelectOption>
                                                                        )))
                                                                        }                                            
                                                                    </IonSelect>                       
                                                                </IonCol>                                                         
                                                            </IonRow> 
                                                            }

                                                            {trailSrc === 'new-trail' &&                                                             
                                                            <IonRow className='ion-margin-top'>
                                                                <IonCol size='12' className='ion-no-padding'>
                                                                    <TrailCreateEmbed nameRef={nameRef} routeType={routeType} setRouteType={setRouteType} routeTextRef={routeTextRef} routeStartTextRef={routeStartTextRef} routeEndTextRef={routeEndTextRef} onRouteNameChange={generateTimerName} />
                                                                </IonCol>
                                                            </IonRow>
                                                            }   
   
                                                            {trailSrc === 'saved-trail' && 
                                                            <IonRow>
                                                                <IonCol size='12'>
                                                                    <IonButton 
                                                                        color={'tertiary'} 
                                                                        fill={'outline'} 
                                                                        onClick={() => toggleTrailSrc('new-trail')}>
                                                                            Enter a New Trail
                                                                    </IonButton>                                                                   
                                                                </IonCol> 
                                                            </IonRow>
                                                            }
                                                        </IonGrid>
                                                    </>)
                                                }
                                            </IonCardContent>
                                        </IonCard>
                                    </IonCol>
                                </IonRow>
                                }
                               
                            </IonGrid>
                        </IonCardContent>
                    </IonCard>

                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid> 
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2 className='ion-no-margin'><IonText color={'tertiary'}>Who?</IonText></h2>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Who should we notify if you don't check in for this Timer?</b></IonLabel><br />
                                        <IonNote>Select Your Emergency Contacts</IonNote>
                                    </IonCol>
                                    <IonCol size='12'> 
                                        <IonRow>
                                            {!loading
                                                ? (availableContacts !== undefined && availableContacts.length > 0
                                                    ? (availableContacts.map((contact:any, index:any) => (
                                                        <IonCol key={index} size='12' sizeSm='6'>
                                                            <IonCheckbox 
                                                                color={'secondary'}
                                                                checked={checkedContacts.includes(contact.contactToken)}
                                                                key={index}
                                                                labelPlacement="end"
                                                                name='contactTokens[]'
                                                                onIonChange={(e) => handleContactSelection(e, contact.contactToken)}
                                                                value={contact.contactToken}
                                                                >
                                                                {contact.contactFirstName} {contact.contactLastName}<br/> {contact.contactEmail}
                                                            </IonCheckbox>
                                                        </IonCol>)))
                                                    : (<>
                                                        <p>You have no verified SoloWise Contacts.</p>
                                                        <p>You must have at least one verified SoloWise Contact to set a Timer.</p>
                                                        <p><Link to='/account/contact/create'><IonIcon icon={addCircleOutline}></IonIcon> Add an Emergency Contact</Link></p>
                                                    </>)                                            
                                                )   
                                                : <p>No options available.</p>
                                            }
                                        </IonRow>
                                    </IonCol>
                                </IonRow>

                                {level?.memberLevelID > 1 &&
                                  <>                                    
                                    <IonRow className='ion-margin-bottom ion-margin-top'>
                                        <IonCol>
                                            <IonText className='link' color={'secondary'} onClick={toggleOtherPeople}>{otherPeopleOpen ? '- Remove' : '+ Add'} other people with you</IonText>
                                        </IonCol>
                                    </IonRow>

                                    {otherPeopleOpen &&
                                      <>
                                        <IonRow className='ion-margin-top'>
                                            <IonCol size='12' sizeSm='6'> 
                                                <IonLabel color={'dark'}><b>How many <em>other</em> people will be with you?</b></IonLabel>
                                                <IonInput  className='ion-margin-top' fill='outline' label='Number of other people' labelPlacement='stacked' min="1" max='20' step='1' type='number' name='partySize' onIonChange={handlePartySizeChange} value={partySize}></IonInput>                 
                                            </IonCol>
                                        </IonRow>

                                        { settings.menuPartners == '1' && partySize != '0' &&
                                            <IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>Select the SoloWise Partners that will be joining you</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {activePartners !== undefined && activePartners.length > 0
                                                            ? activePartners.map((partner:any, index:any) => (
                                                                <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                    <IonCheckbox color={'secondary'} labelPlacement="end" name='partnerTokens[]' key={index} onIonChange={getPartnerObjects} value={partner.partnerToken}>{partner.firstName} {partner.lastName}</IonCheckbox>
                                                                </IonCol>))
                                                            : <p>No options available.</p>                         
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>
                                        }

                                        { settings.menuKids == '1' && partySize != '0' &&
                                            <IonRow className='ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>Select the SoloWise Kids that will be with you</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {availableKids.length > 0
                                                            ? (availableKids !== undefined && availableKids.map((kid:any, index:any) => (
                                                                <IonCol key={index} sizeXs='12' sizeSm='6' sizeMd='4'>
                                                                    <IonCheckbox color={'secondary'} labelPlacement="end" name='kidTokens[]' key={index} value={kid.kidToken}>{kid.kidFirstName} {kid.kidLastName}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>
                                        }

                                        { partySize != '0' &&
                                            <IonRow className='ion-margin-bottom ion-margin-top'>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>Who else is with you?</b></IonLabel><br />
                                                    <IonNote>You can list the names and information of others with you, who are not registered with SoloWise.</IonNote>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        <IonTextarea autocapitalize='sentences' autoGrow={true} fill='outline' name='partnerText' placeholder=''></IonTextarea> 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>
                                        }
                                      </>  
                                    }
                                  </>
                                }
                                
                            </IonGrid>
                        </IonCardContent>
                    </IonCard>

                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid> 
                                <IonRow>
                                    <IonCol size='12'>
                                        <h2><IonText color={'tertiary'}>What?</IonText></h2>
                                    </IonCol>
                                </IonRow>
                                
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>What will you be doing?</b></IonLabel>
                                        <IonText><p>Describe any pertinent activities, such as hiking, socializing, meeting a client, running errands, etc.</p></IonText>
                                    </IonCol>
                                    <IonCol size='12'> 
                                        <IonTextarea autocapitalize='sentences' counter fill='outline' maxlength={500} name='timerActivity' placeholder=''></IonTextarea>
                                    </IonCol>
                                </IonRow>

                                <IonRow className='ion-margin-bottom ion-margin-top'>
                                    <IonCol>
                                        <IonText className='link' color={'secondary'} onClick={toggleTimerDetailOpen}>{timerDetailOpen ? '- Remove' : '+ Add'} Optional Timer Details</IonText>
                                    </IonCol>
                                </IonRow>
                                
                                {timerDetailOpen &&
                                  <>
                                    <IonRow className='ion-margin-top'>
                                        <IonCol size='12'>
                                            <IonLabel color={'dark'}><b>What other information does your Emergency Contact need to know?</b></IonLabel>
                                            <IonText><p>Include the name and phone number of the agencies your emergency contact should call. This could be the local police, search and rescue team, etc. Also include information about caring for your pets, etc.</p></IonText>
                                        </IonCol>
                                        <IonCol size='12'>
                                            <IonTextarea autocapitalize='sentences' autoGrow={true} counter fill='outline' maxlength={500} name='timerNotes' placeholder='' ref={notesRef}></IonTextarea>                               
                                        </IonCol>
                                    </IonRow>

                                    { level?.memberLevelID > 1 && settings?.menuPets == '1' &&
                                    <>
                                        <IonRow className='ion-margin-bottom ion-margin-top'>
                                            <IonCol>
                                                <IonText className='link' color={'secondary'} onClick={togglePets}>{petsOpen ? '- Remove' : '+ Add'} pets with you</IonText>
                                            </IonCol>
                                        </IonRow>

                                        {petsOpen &&
                                        <IonRow className='ion-margin-bottom ion-margin-top'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>SoloWise Pets</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'> 
                                                <IonRow>
                                                    {availablePets !== undefined && availablePets.length > 0
                                                        ? (availablePets.map((pet:any, index:any) => (
                                                            <IonCol key={index} sizeXs='12' sizeSm='6'>
                                                                <IonCheckbox color={'secondary'} labelPlacement="end" name='petTokens[]' key={index} value={pet.petToken}>{pet.petName}{pet.petBreed != '' && ', the ' + pet.petBreed}</IonCheckbox>
                                                            </IonCol>)))
                                                        : (<p>No options available.</p>)                                            
                                                    } 
                                                </IonRow>
                                            </IonCol>
                                        </IonRow>
                                        }
                                    </>
                                    }

                                    { settings?.menuVehicles == '1' && profiles?.vehicles >= 1 &&
                                      <>             
                                        <IonRow className='ion-margin-bottom ion-margin-top'>
                                            <IonCol>
                                                <IonText className='link' color={'secondary'} onClick={toggleVehicles}>{vehiclesOpen ? '- Remove' : '+ Add'} vehicles with you</IonText>
                                            </IonCol>
                                        </IonRow>

                                        {vehiclesOpen &&
                                          <>
                                            <IonRow>
                                                <IonCol size='12'>
                                                    <IonLabel color={'dark'}><b>SoloWise Vehicles parked at { typeSetting == '' || typeSetting == 'STATIONARY' ? 'this' : 'the Starting' } Place</b></IonLabel>
                                                </IonCol>
                                                <IonCol size='12'> 
                                                    <IonRow>
                                                        {vehiclesStart !== undefined && vehiclesStart.length > 0
                                                            ? (vehiclesStart.map((vehicle:any, index:any) => (
                                                                <IonCol key={index} size='12' sizeSm='6'>
                                                                    <IonCheckbox 
                                                                        color={'secondary'}
                                                                        checked={selectedVehiclesStart.length > 0 ? selectedVehiclesStart.indexOf(vehicle.vehicleToken) >= 0 : false}
                                                                        id='vehicleTokensStart'
                                                                        labelPlacement="end" 
                                                                        name='vehicleTokensStart[]' 
                                                                        key={index} 
                                                                        onIonChange={handleVehicleSelect} 
                                                                        value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                                </IonCol>)))
                                                            : (<p>No options available.</p>)                                            
                                                        } 
                                                    </IonRow>
                                                </IonCol>
                                            </IonRow>

                                            { routeType !== '' &&
                                                <IonRow className='ion-margin-top'>
                                                    <IonCol size='12'>
                                                        <IonLabel color={'dark'}><b>SoloWise Vehicles driven or parked somewhere along the way</b></IonLabel>
                                                    </IonCol>
                                                    <IonCol size='12'> 
                                                        <IonRow>
                                                            {vehiclesEnroute !== undefined && vehiclesEnroute.length > 0
                                                                ? (vehiclesEnroute.map((vehicle:any, index:any) => (
                                                                    <IonCol key={index} size='12' sizeSm='6'>
                                                                        <IonCheckbox 
                                                                            color={'secondary'}
                                                                            checked={selectedVehiclesEnroute.indexOf(vehicle.vehicleToken) >= 0}
                                                                            id='vehicleTokensEnroute'
                                                                            labelPlacement="end" 
                                                                            name='vehicleTokensEnroute[]' 
                                                                            key={index} 
                                                                            onIonChange={handleVehicleSelect} 
                                                                            value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                                    </IonCol>)))
                                                                : (<p>No options available.</p>)                                            
                                                            } 
                                                        </IonRow>
                                                    </IonCol>
                                                </IonRow>
                                            }

                                            { routeType === 'ONE-WAY' &&
                                                <IonRow className='ion-margin-top'>
                                                    <IonCol size='12'>
                                                        <IonLabel color={'dark'}><b>SoloWise Vehicles parked at the Ending Place?</b></IonLabel>
                                                    </IonCol>
                                                    <IonCol size='12'> 

                                                        <IonRow>
                                                            {vehiclesEnd !== undefined && vehiclesEnd.length > 0
                                                                ? (vehiclesEnd.map((vehicle:any, index:any) => (
                                                                    <IonCol key={index} size='12' sizeSm='6'>
                                                                        <IonCheckbox 
                                                                            color={'secondary'}
                                                                            checked={selectedVehiclesEnd.indexOf(vehicle.vehicleToken) >= 0}
                                                                            id='vehicleTokensEnd'
                                                                            labelPlacement="end" 
                                                                            name='vehicleTokensEnd[]' 
                                                                            key={index} 
                                                                            onIonChange={handleVehicleSelect} 
                                                                            value={vehicle.vehicleToken}>{vehicle.vehicleYear} {vehicle.vehicleModel}</IonCheckbox>
                                                                    </IonCol>)))
                                                                : (<p>No options available.</p>)                                            
                                                            } 
                                                        </IonRow>

                                                    </IonCol>
                                                </IonRow>
                                            }
                                          </>
                                        }
                                      </>
                                    }

                                    <IonRow className='ion-margin-bottom ion-margin-top'>
                                        <IonCol>
                                            <IonText className='link' color={'secondary'} onClick={toggleEquipment}>{equipmentOpen ? '- Remove' : '+ Add'} equipment with you</IonText>
                                        </IonCol>
                                    </IonRow>

                                    {equipmentOpen &&                  
                                        <IonRow className='ion-margin-top'>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>What safety / survival equipment will you have with you?</b></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'>                                         
                                                    
                                                <IonAccordionGroup>                                        
                                                    <IonAccordion>
                                                        <IonItem slot="header" color="light">
                                                            <IonLabel>Equipment List</IonLabel>
                                                        </IonItem>
                                                        <div slot="content">
                                                            <IonCard>
                                                                <IonCardContent>
                                                                    <IonRow>
                                                                    {!loading
                                                                        ? (equipment !== undefined && equipment.length > 0
                                                                            ? (equipment.map((eq:any, index:any) => (
                                                                                <IonCol key={index} size='12' sizeSm='6'>
                                                                                    <IonCheckbox 
                                                                                        color={'secondary'}
                                                                                        checked={checkedEquipment.includes(eq.equipmentID)}
                                                                                        key={index}
                                                                                        labelPlacement="end"
                                                                                        name='equipmentIDs[]'
                                                                                        onIonChange={(e) => handleEquipmentSelect(e, eq.equipmentID)}
                                                                                        value={eq.equipmentID}
                                                                                        >
                                                                                        {eq.equipmentName}
                                                                                    </IonCheckbox>
                                                                                </IonCol>)))
                                                                            : (<>
                                                                                <p>Loading Equipment List...</p>   
                                                                            </>)   
                                                                        )   
                                                                        : <p>No options available.</p>
                                                                    }
                                                                    </IonRow>
                                                                </IonCardContent>
                                                            </IonCard>                            
                                                        </div>
                                                    </IonAccordion> 
                                                </IonAccordionGroup>
                                                
                                            </IonCol>
                                        </IonRow>                                      
                                    }
                                  </>
                                }
                            </IonGrid>
                        </IonCardContent>
                    </IonCard>

                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid>                                
                                <IonRow className='ion-margin-bottom'>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Name this Timer</b> </IonLabel><br />
                                        <IonNote>This can be a short description, like "Daily Check-in", "Morning Commute", "Evening Walk", etc.</IonNote>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonInput 
                                            autocapitalize='sentences' 
                                            clearInput={true}
                                            counter 
                                            fill='outline' 
                                            name='timerName' 
                                            placeholder='' 
                                            type='text' 
                                            ref={nameRef} 
                                            maxlength={50}></IonInput>                                        
                                    </IonCol>                                  
                                </IonRow>
                            </IonGrid>
                        </IonCardContent>
                    </IonCard>

                    <IonCard>
                        <IonCardContent>                            
                            <IonGrid> 
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton color={disableSubmit ? 'primary' : 'secondary'} expand='block' id='timerFormSubmit' type='submit' disabled={disableSubmit}>Set Timer</IonButton>                        
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonCardContent>
                    </IonCard>
                </form>
                }

            </IonContent>
        </IonPage>
    );
};

export default TimerCreate;